<template>
  <div class="check_remainder_modal">
    <div class="check_remainder_modal__backdrop" ref="backdrop" @click.once="toggle()"></div>

    <div class="check_remainder_modal__inner pt-89 pl-55 pr-55 flex column" ref="modal_inner">
      <div class="check_remainder_modal__x-btn pointer" @click.once="toggle()">
        <svg xmlns="http://www.w3.org/2000/svg" width="22.121" height="22.121" viewBox="0 0 22.121 22.121">
          <g id="CLOSE_копия" data-name="CLOSE копия" transform="translate(1.061 1.061)">
            <line id="Фигура_562" data-name="Фигура 562" x2="20" y2="20" fill="none" stroke="#4d4d4f"
              stroke-width="3" />
            <line id="Фигура_562_копия" data-name="Фигура 562 копия" x1="20" y2="20" fill="none" stroke="#4d4d4f"
              stroke-width="3" />
          </g>
        </svg>
      </div>
      <div class="flex column">
        <h2 class="f-34 regular uppercase mb-34">
          {{ $fn.tr("ნაშთის შემოწმება") }}
        </h2>
        <h3 class="f-14 bold mb-55" style="color: #4d4d4f">
          {{ $fn.tr("ნაშთის შემოწმების მოდალის თიზერი") }}
        </h3>

        <div class="check_remainder_modal__card">
          <img :src="gift_card_image" />

          <div class="check_remainder_modal__card--inner flex column">
            <div class="check_remainder_modal--row-1 mb-34Z flex column">
              <span class="f-white f-14 bold mb-14">{{
                  $fn.tr("ბარათის ნომერი")
              }}</span>
              <div class="flex card-digits-wrapper">
                <input type="text" @input="check_digits_phone($event, 0)" ref="card_field" placeholder="0000"
                  class="mr-20" card-field="0" />
                <input type="text" @input="check_digits_phone($event, 1)" ref="card_field" placeholder="0000"
                  class="mr-20" card-field="1" />
                <input type="text" @input="check_digits_phone($event, 2)" ref="card_field" placeholder="0000"
                  class="mr-20" card-field="2" />
                <input type="text" @input="check_digits_phone($event, 3)" ref="card_field" placeholder="0000"
                  class="mb-20" card-field="3" />
              </div>

              <div class="flex card-date-wrapper">
                <el-select v-model="card_date_mm" placeholder="00" class="mr-20">
                  <el-option v-for="item in months" :key="item.value" :label="item.value" :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="card_date_yy" placeholder="00">
                  <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>

        <button class="
            check_remainder_modal__button
            flex
            al-center
            f-white
            pangram-extrabold
            pointer
          " @click.prevent="order($event)">
          {{ $fn.tr("შემოწმება") }}
        </button>

        <div class="check_remainder_modal__card--success" v-if="success">
          <span class="f-21 bold">{{ $fn.tr("ხელმისაწვდომი თანხა:") }} {{ price }} {{ $fn.tr("ლარი") }}</span>
        </div>
        <div class="check_remainder_modal__card--error" v-if="res_error">
          <span class="f-21 bold">{{ $fn.tr("დაფიქსირდა შეცდომა") }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getCardData from "../../mixins/getCardData"
export default {
  mixins: [getCardData],
  data() {
    return {
      card_field: [[], [], [], []],
      card_field_final: [],
      months: [
        {
          value: "01"
        },
        {
          value: "02"
        },
        {
          value: "03"
        },
        {
          value: "04"
        },
        {
          value: "05"
        },
        {
          value: "06"
        },
        {
          value: "07"
        },
        {
          value: "08"
        },
        {
          value: "09"
        },
        {
          value: "10"
        },
        {
          value: "11"
        },
        {
          value: "12"
        }
      ],
      card_date_mm: "",
      card_date_yy: "",

      //
      name_field: "",
      service: "",
      //
      not_passed: true,
      success: false,
      res_error: false,
      fail: false
    };
  },
  mounted() {
    console.log(this.$refs);
    this.gift_card_image;
    console.log(this.months);
  },
  methods: {
    toggle() {
      let _timeout, TIMEOUT;
      this.$refs.modal_inner.classList.remove("active");

      TIMEOUT = setTimeout(() => {
        this.$refs.backdrop.classList.remove("active");
        clearTimeout(TIMEOUT);
      }, 500);
      this.$store.commit("main/setState", {
        key: "dynamicBalance",
        val: null
      });
      _timeout = setTimeout(() => {
        this.$store.commit("main/setState", {
          key: "check_remainder_modal",
          val: false
        });
        clearTimeout(_timeout);
      }, 921);
    },

    check_digits_phone(e, box_id) {
      e.preventDefault();
      let val = e.target.value,
        that = this;
      let card_fields = document.querySelectorAll(".card-digits-wrapper input");
      function check_length() {
        if (that.card_field[box_id].length === 1) {
          if (that.card_field[box_id][0].toString().length >= 4) {
            if (val.toString().length >= 4) {
              e.target.value = that.card_field[box_id][0];
              return "disabled";
            }
          } else {
            return "enabled";
          }
        }
      }
      console.log(isNaN(val));
      if (val && !isNaN(val)) {
        if (check_length() === "disabled") {
          return;
        }
        let card_num = e.srcElement.getAttribute("card-field");
        this.card_field[box_id] = [];
        this.card_field[box_id].push(val);
        if (
          card_num == box_id &&
          this.card_field[box_id][0].toString().length === 4 &&
          box_id !== 3
        ) {
          card_fields[box_id + 1].focus();
        }
      } else if (val.length === 0) {
        this.card_field[box_id] = "";
      } else {
        if (this.card_field[box_id].length >= 1) {
          e.target.value = this.card_field[box_id][0];
        } else {
          e.target.value = "";
        }
      }
      // console.log(this.card_field);
    },
    async checkGiftCardBallance(cardLastNumber, expireYear, expireMonth) {
      // if (!this.$cookies.get("_uctoken")) return false;

      const res = await this.$fn.postData(
        "main/serviceCaller?callerId=CityMall_CheckGiftCardBallance",
        {
          uctoken: this.$cookies.get("_uctoken"),
          cardLastNumber,
          expireYear,
          expireMonth
        }
      );
      console.log(res, 'res')
      if (res?.data?.info?.hasOwnProperty('ballance')) {
        this.$store.commit("main/setState", {
          key: "dynamicBalance",
          val: Number(_.get(res, "data.info.ballance"))
        });
        console.log(this.$store.state.main.dynamicBalance, 'if1')
      } else {
        this.$store.commit("main/setState", {
          key: "dynamicBalance",
          val: null
        });
        console.log(this.$store.state.main.dynamicBalance, 'if2')

      }

      console.log(this.$store.state.main.dynamicBalance, 'dynamicbalance')
      console.log(res, 'res')
      console.log(_.get(res, "data.info.ballance"), 'data.info.ballance')


      if (this.$store.state.main.dynamicBalance === null) {
        this.success = false;
        this.res_error = true;

      } else {
        this.success = true;
        this.res_error = false;

      }


      if (res.status !== 200 || !_.get(res, "data.info")) {
        return false;
      }
    },


    async order() {
      // this.success = true;
      this.card_field_final = this.card_field[0].concat(
        this.card_field[1],
        this.card_field[2],
        this.card_field[3]
      );
      this.card_field_final = this.card_field_final.join("");
      this.not_passed = false;
      console.log(this.card_field_final);

      await this.checkGiftCardBallance(this.card_field_final, this.card_date_yy, this.card_date_mm.toString());

    }
  },
  watch: {
    toggler: {
      immediate: true,
      handler(ns) {
        console.log(ns);
        let _timeout, TIMEOUT;
        if (ns == true) {
          _timeout = setTimeout(() => {
            this.$refs.backdrop?.classList?.add("active");
            clearTimeout(_timeout);
          }, 200);
          TIMEOUT = setTimeout(() => {
            this.$refs.modal_inner?.classList?.add("active");
            clearTimeout(TIMEOUT);
          }, 400);

          document.body.classList.add("ov_hidden");
          document.getElementsByTagName("html")[0].removeAttribute("style");
        } else {
          document.body.classList.remove("ov_hidden");
        }
      }
    }
  },
  computed: {
    price() {
      return _.get(this.$store.state.main, 'dynamicBalance')
    },
    toggler() {
      return this.$store.state.main.check_remainder_modal;
    },
    gift_card_image() {
      let gift_card = Object.entries(
        this.$store.state.main.indx.widgets.gift_card_image
      )[0][1][0].url;
      return gift_card;
    },
    years() {
      let year_arr = [];
      for (let i = 0; i <= 20; i++) {
        let year_now = new Date(
          new Date().setFullYear(new Date().getFullYear() + i)
        ).getFullYear();
        console.log(year_now);
        let year_chars = year_now.toString().split("");
        let year_label = year_chars[2] + year_chars[3];
        let year_object = {
          value: year_label,
          label: year_label
        };
        year_arr.push(year_object);
      }
      console.log(year_arr);

      return year_arr;
    }
  }
};
</script>

<style lang="scss">
.el-select-dropdown {
  z-index: 99999999999999 !important;
  // left: 80px !important;
  // top: 0px !important;
}

.el-icon-arrow-up:before {
  content: url("../../assets/imgs/arrow-white.svg");
}

.el-select .el-input .el-select__caret {
  transform: rotateZ(120deg);
}

.el-select .el-input .el-select__caret.is-reverse {
  transform: rotateZ(120deg);
}

.el-input__icon {
  width: auto;
  margin-right: 20px;
}

.el-popper[x-placement^="bottom"] {
  margin-top: 0;
}

.el-popper .popper__arrow,
.el-popper .popper__arrow::after {
  display: none;
}

.el-select-dropdown__item.selected {
  color: $black;
}

.el-select-dropdown {
  border: 2px solid $black;
  border-top: none;
  border-radius: 0;
  will-change: transform;
}

.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus {
  border-color: white;
}

.check_remainder_modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999999999;

  &__backdrop {
    transition: 0.4s;
    @include modal_bg(#1a1a1a, 3);
    opacity: 0;

    &.active {
      opacity: 0.5;
    }
  }

  &__x-btn {
    position: absolute;
    top: 30px;
    right: 30px;
    width: 23px;
    height: 23px;
    z-index: 5;

    svg path {
      transition: 0.4s;
    }

    @include hover {
      svg path {
        fill: $red;
      }
    }
  }

  &__inner {
    position: absolute;
    top: 0;
    right: 0;
    transform: translateX(100%);
    background-color: white;
    z-index: 4;
    width: 727px;
    transition: 0.6s;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 55px;

    &.active {
      transform: translateX(0);
    }
  }

  &__button {
    background-color: #4d4d4f;
    transition: 0.4s;
    width: fit-content;
    height: 60px;
    padding-left: 82px;
    padding-right: 82px;

    @include hover {
      background-color: black;
    }
  }

  input,
  textarea {
    height: 60px;
    border-radius: 0px;
    border: 2px solid #c9c9ca;
    font-size: 13px;
    line-height: 24px;
    // font-family: "Hm-Pangram-bold";
    font-family: "Firago-Book";
    padding: 20px;
    color: #4d4d4f;
    transition: 0.4s;

    border-color: #c9c9ca;

    &::placeholder {
      color: rgba(96, 98, 102, 0.8);
    }

    &:focus {
      border-color: black;
    }
  }

  &__card {
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    width: 617px;
    height: 392px;
    margin-bottom: 34px;

    &--inner {
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 10;
      padding-top: 151px;
      padding-left: 20px;
    }

    &--success {
      background-color: rgba($yellow, 0.4);
      padding-top: 25px;
      padding-bottom: 31px;
      padding-left: 20px;
      margin-top: 34px;
      position: relative;
      width: calc(100% - 10px);

      @media (max-width: 1200px) {
        width: calc(100% - 50px);
      }

      @media (max-width: 652px) {
        width: calc(100% - 30px);
      }

    }

    &--error {
      span {
        color: $red;
      }

      margin-top: 34px;
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    input {
      position: relative;
      background-color: transparent;
      border-color: white;
      border-radius: 10px;
      width: 129px;
      padding: 20px 40px;
      color: white;
      text-align: center;

      &:focus {
        border-color: white;
      }

      &::placeholder {
        color: rgba(255, 255, 255, 0.3);
      }
    }
  }

  .el-radio,
  .el-radio span {
    color: rgba(96, 98, 102, 0.8);
    // font-family: "Hm-Pangram-bold";
    font-family: "Firago-Book";
  }

  .el-radio__inner {
    width: 20px;
    height: 20px;
    transition: 0.4s;

    &:hover {
      border-color: #ffcb05;
    }
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: #4d4d4f;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #ffcb05;
    border-width: 2px;
    background: white;

    &:after {
      background-color: #ffcb05;
      width: 10px;
      height: 10px;
    }
  }

  textarea {
    height: 120px;
  }

  input[type="radio"] {
    -webkit-appearance: radio;
  }

  @media (max-width: 1200px) {
    &__inner {
      padding-top: 55px;
      padding-left: 30px;
      padding-right: 30px;

      .mb-34 {
        margin-bottom: 21px;
      }

      .mb-55 {
        margin-bottom: 34px;
      }

      .mb-30 {
        margin-bottom: 21px;
      }
    }
  }

  @media (max-width: 767px) {
    &__card {
      input {
        width: 100px;
      }
    }

    &__inner {
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      padding-left: 21px;
      padding-right: 21px;
      padding-top: 34px;
      padding-bottom: 34px;

      .mb-55 {
        margin-bottom: 21px;
      }

      .f-34 {
        font-size: 21px;
      }
    }

    &__button {
      height: 40px;
      padding-left: 55px;
      padding-right: 55px;
    }

    input {
      height: 40px;
    }
  }

  @media (max-width: 660px) {
    &__card {
      width: 367px;
      height: 233px;

      &--inner {
        padding-top: 80px;
        padding-left: 12px;
        padding-right: 12px;
      }

      input {
        width: 77px;
        margin-right: 12px;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 12px;
        padding-bottom: 12px;
      }

      .el-select {
        margin-right: 12px;

        input {
          margin-right: 0;
          padding-right: 35px;
        }

        .el-input__suffix {
          right: 0;
        }
      }
    }
  }

  @media (max-width: 413px) {
    &__inner {
      padding-left: 12px;
      padding-right: 12px;
    }

    &__card {
      width: 293px;
      height: 186px;

      &--inner {
        padding-top: 41px;
        padding-left: 10px;
        padding-right: 10px;
      }

      input {
        width: 59px;
        margin-right: 10px;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 12px;
        padding-bottom: 12px;
      }

      .el-select {
        margin-right: 12px;

        input {
          margin-right: 0;
          padding-right: 25px;
        }

        .el-input__suffix {
          right: -10px;
        }
      }
    }
  }
}
</style>
